import { prop } from 'ramda';
import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { usePushSubscription } from 'server';
import { useUserSelector } from 'js/store/hooks';
import { useFormatter } from 'js/hooks/useFormatter';

import * as actions from '../store/actions';

const useHandleBalanceUpdate = () => {
    const dispatch = useDispatch();
    const formatter = useFormatter();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    return useCallback(response => {
        if (!isLoggedIn) {
            return;
        }

        const balances = response.data.balances.reduce((balanceList, balance) => {
            balanceList[balance.balanceType] = balance.balance;

            return balanceList;
        }, {});
        const casinoGamingBalance = balances?.casino_gaming_balance;
        const { amount: totalAmount, currencyCode } = casinoGamingBalance;
        const formattedBalance = formatter.formatCurrency(totalAmount, { currencyCode });
        const balance = {
            balances,
            totalAmount,
            formattedBalance
        };

        dispatch(actions.userSetAttributesAction({ balance }));

        dispatcher.dispatch('user:balanceUpdated', response);
    }, [isLoggedIn, dispatch, formatter]);
};

export const useBalanceUpdateSubscription = () => {
    const handleBalanceUpdate = useHandleBalanceUpdate();

    usePushSubscription([32010, 31021], () => (push) => handleBalanceUpdate(push));
};
